module.exports = __webpack_public_path__ + "img/img-12.1553c2b0.jpg";